// Configuration constants
export const CONFIG = {
  // Expected receiver RFC for validation
  EXPECTED_RECEIVER_RFC: 'BLI180227F23',

  // n8n Webhook URL (from environment)
  WEBHOOK_URL: import.meta.env.VITE_WEBHOOK_URL || '',

  // Supported currencies
  CURRENCIES: ['MXN', 'USD'] as const,

  // Payment methods
  PAYMENT_METHODS: {
    PUE: 'PUE',
    PPD: 'PPD',
  } as const,
} as const;

export type Currency = (typeof CONFIG.CURRENCIES)[number];
export type PaymentMethod = keyof typeof CONFIG.PAYMENT_METHODS | '';

export const API_BASE_URL = import.meta.env.VITE_API_URL || '';
